/* 11 · Suivez-nous sur Instagram (Shopify : assets/obaia-section-instagram.js)
   La rangée de photos défile au doigt, au trackpad ou à la souris ; au départ, la première photo est coupée à gauche comme sur la maquette. */
OBAIA.section('instagram', {
  init: function (root) {
    var row = OBAIA.$('[data-insta-row]', root);
    if (!row) return;
    // Départ comme la maquette : la 1re photo légèrement coupée à gauche (66 px en mobile, 3,33 % de l'écran en desktop)
    row.scrollLeft = OBAIA.isMobile() ? 66 : Math.round(window.innerWidth * 0.033334);
    // Desktop : on peut aussi faire glisser la rangée à la souris
    var x0 = 0, s0 = 0, bouge = false, appui = false;
    row.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      appui = true; bouge = false; x0 = e.clientX; s0 = row.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!appui) return;
      var dx = e.clientX - x0;
      if (!bouge && Math.abs(dx) > 4) { bouge = true; row.classList.add('is-glisse'); }
      if (bouge) row.scrollLeft = s0 - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!appui) return; appui = false;
      setTimeout(function () { row.classList.remove('is-glisse'); }, 0);
    });
    row.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }
});
